import HorsesSection from './HorsesSection';

export default HorsesSection;
